import { CitationsJWT } from '@chegg-wt/core/types/auth'
import { Site } from '@chegg-wt/core/types/site'
import {
  CHEGG,
  BIBME,
  CITATION_MACHINE,
  EASYBIB,
  CITE_THIS_FOR_ME,
} from '@chegg-wt/core/constants/site'
import { parseJwt } from '@chegg-wt/core/utils/jwt'
import { AppState } from '../../types'
import { loggedInSelector } from '../../user/selectors'

export const LOGGED_IN = 'hard_logged_in' as const
export const LOGGED_OUT = 'logged_out' as const
export const getAuthState = (state: AppState) =>
  loggedInSelector(state) ? LOGGED_IN : LOGGED_OUT

export const ACTIVE = 'active' as const
export const NON_MEMBER = 'non_member' as const
export const getSubscriptionStatus = (state: AppState) => {
  switch (state.user.user.role) {
    case 'mybibpro':
      return ACTIVE
    default:
      return NON_MEMBER
  }
}
export const CHEGG_PRODUCT = 'chegg_writing' as const
export const EASYBIB_PRODUCT = 'easybib_plus' as const
export const BIBME_PRODUCT = 'bibme_plus' as const
export const CITATION_MACHINE_PRODUCT = 'citation_machine_plus' as const
export const CITE_THIS_FOR_ME_PRODUCT = 'cite_this_for_me_plus' as const

type SubscriptionProduct =
  | typeof CHEGG_PRODUCT
  | typeof EASYBIB_PRODUCT
  | typeof BIBME_PRODUCT
  | typeof CITATION_MACHINE_PRODUCT
  | typeof CITE_THIS_FOR_ME_PRODUCT

export type ProductMap = { [key in Site]: SubscriptionProduct }

export const productMap: ProductMap = {
  [CHEGG]: CHEGG_PRODUCT,
  [BIBME]: BIBME_PRODUCT,
  [CITATION_MACHINE]: CITATION_MACHINE_PRODUCT,
  [EASYBIB]: EASYBIB_PRODUCT,
  [CITE_THIS_FOR_ME]: CITE_THIS_FOR_ME_PRODUCT,
}

export const getCheggUserUuid = (state: AppState) => {
  if (state.user.jwt) {
    try {
      const jwt: CitationsJWT = parseJwt(state.user.jwt)
      return jwt.cheggUserUuid
    } catch {
      return null
    }
  }
  return null
}
